// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { History } from 'react-router-dom';
import { connect } from 'react-redux';
import { resetPassword, setAuthForm, setFormErrors, unsetError } from '../../actions/auth';
import { fieldError, genericFormError } from '../../store/reducers/auth';
import AuthInput from '../shared/AuthInput';
import AuthLayout from '../layouts/AuthLayout';
import Button from '../shared/Button';
import AuthError from '../shared/AuthError';
import type { AuthState, FormError } from '../../store/reducers/auth';
import validate from '../../validators/forgot-password';

type AuthForm = {
  email?: string,
  password?: string
}

type Props = {
  history: History,
  auth: AuthState,
  formError: FormError,
  resetPassword: (email: string) => Promise<void>,
  unsetError: (field: string) => void,
  setFormErrors: (errors: FormError[]) => void,
  fieldError: (field: string) => FormError,
  setAuthForm: (form: AuthForm) => void,
  location: any,
} & WithTranslation
class Login extends Component<Props> {
  props: Props

  componentWillMount() {
    this.resetForm();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      this.resetForm();
    }
  }

  resetForm() {
    this.props.setAuthForm({
      password: ''
    });
    this.props.setFormErrors([]);
  }

  onSubmit = (event: SyntheticEvent<HTMLFormElement>): void => {
    event.preventDefault();
    const localErrors = validate({
      email: this.props.auth.email
    });
    this.props.setFormErrors(localErrors);
    if (localErrors.length < 1) {
      this.props.resetPassword(this.props.auth.email);
    }
  }

  onChange = (event: SyntheticEvent<HTMLInputElement>): void => {
    this.props.unsetError(event.currentTarget.name);
    this.props.setAuthForm({
      [event.currentTarget.name]: event.currentTarget.value || ''
    });
  }

  render() {
    const { auth, t, i18n } = this.props;
    return (
      <AuthLayout className='login'>
        <div className='auth-page__form'>
          <div className='auth-page__header'>
            <h1>{t('reset_text')}</h1>
            <p>{t('enter_email')}</p>
          </div>
          {(!auth.message || auth.message.length < 1) &&
            <form onSubmit={this.onSubmit} className='auth-form--signup is-functional'>
              <AuthInput
                value={this.props.auth.email}
                onChange={this.onChange}
                name='email'
                label={t('email')}
                type='email'
                error={this.props.fieldError('email') && <AuthError error={this.props.fieldError('email')} />}
              />
              <AuthError error={this.props.formError} />
              <Button
                formButton
                label={t('reset_action')}
                loading={this.props.auth.loading}
              />
            </form>
          }
          {auth.message && auth.code &&
            <p>
              {i18n.exists(`forgotPassword:${auth.code}`)
                ? t(auth.code, { email: this.props.auth.email })
                : auth.message}
            </p>
          }
        </div>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (appState: { auth: AuthState }) => ({
  auth: appState.auth,
  fieldError: (field) => fieldError(appState.auth, field),
  formError: genericFormError(appState.auth)
});

export default withTranslation('forgotPassword')(connect(mapStateToProps, {
  resetPassword,
  setAuthForm,
  setFormErrors,
  unsetError
})(Login));



// WEBPACK FOOTER //
// ./src/components/pages/forgot-password.js